import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { Router } from '@angular/router';
import { UserService } from '@auto-editor/data-access-user';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private userService: UserService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (this.userService.userLoggedIn()) {
      return of(true);
    } else {
      this.router.navigate(['auth'], {
        queryParams: { ...route.queryParams, returnUrl: state.url }
      });
      return of(false);
    }
  }
}
